// Keep the viewer on the configured storage origin, including direct media URLs.
function assetPath(path, baseUrl) {
	if (typeof path !== 'string' || !path) { return ''; }
	try {
		const url = new URL(path, baseUrl + '/');
		if (!url.href.startsWith(baseUrl + '/') || url.username || url.password) { return ''; }
		return url.href.slice(baseUrl.length + 1);
	} catch (error) {
		return '';
	}
}

function previewBlock(block, config) {
	if (!Array.isArray(block.assets) || !block.assets.length) { return null; }
	const types = ['facebook', 'instagram', 'instagram-feed', 'tiktok', 'tiktok-top-ads', 'tiktok-library', 'linkedin', 'pinterest', 'google', 'upload-custom', 'webpage', 'webpage-selection'];
	if (!types.includes(block.type)) { return null; }
	const assets = [];
	for (const asset of block.assets) {
		if (!asset || !['image', 'video'].includes(asset.type)) { return null; }
		const path = assetPath(asset.assetPath || asset.name, config.assetUrl);
		if (!path) { return null; }
		const copy = Object.assign({}, asset, { assetPath: path, name: path, direct: false });
		const cover = asset.cover && assetPath(asset.cover.assetPath, config.assetUrl);
		copy.cover = cover ? { assetPath: cover } : null;
		assets.push(copy);
	}
	const mediaType = block.assetType || (assets.length > 1 ? 'carousel' : assets[0].type);
	if (!['image', 'video', 'carousel'].includes(mediaType)) { return null; }
	// These shared renderers currently only support the listed formats.
	if (block.type.startsWith('tiktok') && (mediaType !== 'video' || assets[0].type !== 'video')) { return null; }
	if (block.type === 'google' && (mediaType !== 'image' || assets[0].type !== 'image')) { return null; }
	if (['pinterest', 'upload-custom'].includes(block.type) && mediaType === 'carousel') { return null; }
	if (block.type === 'linkedin' && mediaType === 'carousel' && assets.some(function (asset) { return asset.type !== 'image'; })) { return null; }
	return Object.assign({}, block, { assets, assetType: mediaType });
}

function previewCards(result, config) {
	if (!result || result.isError || !result.structuredContent) { return []; }
	const data = result.structuredContent.data;
	const rows = Array.isArray(data) ? data : data ? [data] : [];
	const cards = [];
	for (const row of rows) {
		if (!row || typeof row !== 'object') { continue; }
		const block = row.block || row;
		const brand = block.brand || row.brand || {};
		const blockId = block.id || row.blockId;
		const adId = row.block && row.id ? row.id : '';
		const logo = assetPath(brand.logo, config.assetUrl);
		const stats = [];
		for (const name of ['likes', 'comments', 'shares', 'views']) {
			const value = block[name];
			if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
				stats.push({ name, value });
			}
		}
		cards.push({
			block: previewBlock(block, config),
			name: brand.name || block.title || 'Saved ad',
			logo: logo ? config.assetUrl + '/' + logo : '',
			savedAt: row.block ? row.createdAt : null,
			status: ['ACTIVE', 'INACTIVE'].includes(block.status) ? block.status : '',
			mediaType: block.assetType || '',
			stats,
			platform: block.type || 'Ad',
			copy: block.adCopy || '',
			title: block.adTitle || '',
			url: blockId ? config.appUrl + '/?blockid=' + encodeURIComponent(blockId) : config.appUrl,
			publicUrl: adId && config.publicUrl ? config.publicUrl + '/block/' + encodeURIComponent(adId) : '',
		});
	}
	return cards;
}

module.exports = { previewCards };
